<template>
  <div class="home">
    <div class="search-section">
      <SearchBox :external-search-async="switchToSearchMode"
                  :toggle-new-profiles-section="toggleHidden"
                  :search-cancellation="cancelledSearch"/>
    </div>
    <!-- <div v-if="!isAuthenticated" class="greetings default-section">
      <Banner/>
    </div>  -->
    <NewProfiles class="sticky-box"/>
    <div class="listings">
      <div class="loading-box" v-show="loading">
        <LoadingIndicator :message="inSearchMode != true ? 'Loading Jobs' : 'Searching Jobs'"/>
      </div>
      <div class="loading-box" v-show="!loading && error">
        <SystemMessage :message="message"/>
      </div>
      <SystemMessage v-if="loading == false && jobs.length == 0 && !error" :message="message"/>
      <JobListings v-else ref="jobListings"
       :title="title"
       :total="total"
       :jobs="jobs"
       :init-loading="loading"
       :init-loading-error="error"
       :get-page-async="inSearchMode == true ? searchJobsPagesAsync : getPageAsync"
       :reset-pagination="resetPagination"/>
        
    </div>
    </div>
  
</template>

<script>
// @ is an alias to /src
import Greeting from '@/components/Greeting.vue';
import SearchBox from '@/components/SearchBox.vue';
import pagecontent from '../assets/text.json';
import JobListings from '@/components/Jobs/JobListings.vue';
import jobs from '../assets/jobs.json'
import { getJobListingsAsync, searchJobsAsync } from '@/services/public/vacancyService';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import CustomConfirmationMessageModal from '@/components/modals/CustomConfirmationMessageModal.vue';
import SystemMessage from '@/components/Utility/SystemMessage.vue';
import NewProfiles from '@/components/NewProfiles.vue';

export default {
  name: 'HomeView',
  components: {
    SearchBox,
    Greeting,
    JobListings,
    LoadingIndicator,
    CustomConfirmationMessageModal,
    SystemMessage,
    NewProfiles
   
  },
  data() {
    return {
      pagecontent,
      title: "Job Listings",
      total: 0,
      jobs: [],
       modal:{
                caption:"",
                message:""
            },
            confirmModal: null,
            loading: true,
            error:false,
            modalButtonLabel:'Close',
            modalId:"jobListingMessagesModal",
            pageNumber:0,
            inSearchMode: false,
            message:"No job listings are available. Try refreshing the page"
      
            
    }
  },
  computed:{
    isAuthenticated(){
      return this.$store.getters['auth/isAuthenticated'];
    },
    StoredSearchInput(){
        return this.$store.getters["jobs/getSearchInput"] || {};     
    }

  },
  mounted(){
    //this.getJobListings();
  },
  methods: {
    //when paginating use these methods
    updateCollection(items) { 
      // call child method
      this.$refs.jobListings.updateCollection(items);
    },
    clearCollection() {
      this.$refs.jobListings.clearCollection();
    },
    async getJobListings(){
      let data = await getJobListingsAsync(1);
        if(data.success == true){
          this.jobs = data.listings;
          
        }
    },
    closeModal(){

    },
    async getPageAsync(){ //is run from inside JobListings
        this.pageNumber+=1;
        if(this.pageNumber == 1){
          this.startLoading(); 
        }else{
          this.$refs.jobListings.setButtonToLoadingMore();
        }
        setTimeout(async() => {
          try{
          let data = await getJobListingsAsync(this.pageNumber);
          this.stopLoading();
          if(data.success == true){
            this.jobs = data.listings;
            this.total = data.listings[0].count;
            this.setMessageOnZeroCount("Job Listings is currently empty. Please try again later");
            this.$refs.jobListings?.setButtonToSuccessfulLoad();
          }else{
           this.message = "Unable to get Job Listings. Try refreshing the page";
            if(this.pageNumber == 1){
               this.pageNumber-=1;
            this.error = true;
            }else{
              this.pageNumber-=1;
              this.$refs.jobListings.setButtonToLoadingError();
            }
          }
        }catch(e){  
          this.message = "Unable to get Job Listings. Try refreshing the page";  
          this.stopLoading();
          if(this.pageNumber == 1){
            this.pageNumber-=1; //keep this
            this.error = true;
          }else{
            this.pageNumber-=1; //keep this
            this.$refs.jobListings.setButtonToLoadingError();
          }
        }

        }, 4000);
      
        
    },
    startLoading(){
      this.loading = true;
      this.error = false;
    },
    stopLoading(){
      this.loading = false;
    },
    switchToSearchMode(){
      if(this.inSearchMode == false){
        this.inSearchMode = true;
        return; //because when its initially set to true,
                //the search function set in JobListings
                //and will run the initial search on function change
      }else{
        this.resetPagination(); //reset everything for the new search
        this.searchJobsPagesAsync(); //run next search
      }
    },
    turnOffSearchMode(){
      this.title = "Job Listings";
      this.resetPagination();
      this.inSearchMode = false;
      this.loading = true; //to try to re-render JobListings in order to start loading all
    },
    resetPagination(){
      this.jobs = [];
      this.pageNumber = 0;
    },
    cancelledSearch(){
      this.turnOffSearchMode();
     // this.resetPagination();
    },
     async searchJobsPagesAsync(){
            this.title = "Search Results";
            this.pageNumber+=1;
            if(this.pageNumber == 1){
            this.startLoading(); 
            }else{
            this.$refs.jobListings.setButtonToLoadingMore();
            }
            setTimeout(async() => {
            try{
            
            let data = await searchJobsAsync(this.StoredSearchInput, this.pageNumber);
            this.stopLoading();
            
            if(data.success == true){
                this.jobs = data.listings;
                this.total = data.listings[0].count;
                this.setMessageOnZeroCount("No Results Found.");                 
                this.$refs.jobListings?.setButtonToSuccessfulLoad();
                
            }else{
                this.message = "Unable to get Search Results. Please try again later";
                if(this.pageNumber == 1){
                this.pageNumber-=1;
                this.error = true;
                }else{
                this.pageNumber-=1;
                this.$refs.jobListings.setButtonToLoadingError();
                }
            }
            }catch(e){  
            this.message = "Unable to get Search Results. Please try again later";
            this.stopLoading();
            if(this.pageNumber == 1){
                this.pageNumber-=1; //keep this
                this.error = true;
            }else{
                this.pageNumber-=1; //keep this
                this.$refs.jobListings.setButtonToLoadingError();
            }
            }

            }, 4000);
        
        },
        setMessageOnZeroCount(message){ //When no results were fo
          if(this.jobs.length == 0){
            this.message = message;
          }
        },
        toggleHidden(){
          document.querySelector('.sticky-box').classList.toggle("toggle-hidden");
        }


  }

 


}
</script>
<style scoped>

  .home{
   position: relative; /* sticky's boundary is this container */
  }

  .sticky-box {
  position: sticky;
  top: 3.5rem; /* becomes fixed once it's 20px from the top of viewport */
}

  .toggle-hidden{
    display: none;
  }

  .loading-box{
    margin-top:2rem;
  }
 

  @media(max-width:768px){
       .sticky-box {
      position: sticky;
      top: 3.3rem; /* becomes fixed once it's 20px from the top of viewport */
    }
  }

  

  
  
  


  

</style>
